import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['ReviewFormPopupStyles-cvaRoot', 'fixed left-0 top-0 z-[200]', 'w-full h-full']);

export const cvaOverlay = cva([
  'ReviewFormPopupStyles-cvaOverlay',
  'absolute left-0 top-0 ',
  'w-full h-full',
  'bg-cBlack32',
]);

export const cvaClose = cva([
  'ReviewFormPopupStyles-cvaClose',
  'flex items-center justify-center',
  'absolute top-4 right-[59.2rem]',
  'w-5.6 h-5.6',
  'bg-cWhite',
  'rounded-[1.6rem]',
  'cursor-pointer select-none',
]);

export const cvaCloseIcon = cva(['ReviewPopupStyles-cvaCloseIcon', 'w-1.6 h-1.6', 'fill-cBlack']);

export const cvaInner = cva([
  'ReviewFormPopupStyles-cvaInner',
  'overflow-y-auto',
  'absolute right-0 top-0',
  'h-full w-[56rem]',
  'bg-cWhite',
  'rounded-tl-[3.2rem] rounded-bl-[3.2rem]',
]);

export const cvaHeader = cva(['ReviewFormPopupStyles-cvaHeader', 'py-4.8 px-8 pb-3.2', 'bg-cLightGrey']);

export const cvaTitle = cva(['ReviewFormPopupStyles-cvaTitle', 'mb-2.4', 'text-h3 font-secondary']);

export const cvaDescr = cva(['ReviewFormPopupStyles-cvaDescr', 'mb-2.4', 'text-bodyM text-cBlack64']);

export const cvaItem = cva([
  'ReviewFormPopupStyles-cvaItem',
  'flex items-center gap-2.4',
  'py-1.6',
  'border-t border-b border-0.1 border-cBlack16',
]);

export const cvaItemImageWrap = cva([
  'ReviewFormPopupStyles-cvaItemImageWrap',
  'relative overflow-hidden',
  'w-6.6 h-6.4 min-w-[6.4rem]',
  'bg-cWhite',
  'rounded-[1.2rem]',
]);

export const cvaItemImage = cva([
  'ReviewFormPopupStyles-cvaItemImage',
  '!w-5.2 !h-5.2',
  'left-0.6 right-0.6 bottom-0.6 top-0.6',
  'object-contain object-center',
]);

export const cvaItemTitle = cva(['ReviewFormPopupStyles-cvaItemTitle', 'text-bodyM']);

export const cvaBody = cva(['ReviewFormPopupStyles-cvaBody', 'py-3.2 px-8']);

export const cvaGroup = cva(['ReviewFormPopupStyles-cvaGroup', 'not-last:mb-4.8']);

export const cvaGroupTitle = cva(['ReviewFormPopupStyles-cvaGroupTitle', 'font-secondary text-h4'], {
  variants: {
    marginBottomSize: {
      small: 'mb-0.8',
      large: 'mb-2.4',
    },
  },
  defaultVariants: {
    marginBottomSize: 'large',
  },
});

export const cvaFormNote = cva([
  'ReviewFormPopupStyles-cvaFormNote',
  'pt-2.4',
  'text-cBlack64',
  '[&_a]:text-cMediumGreen',
]);

export const cvaTerms = cva(['ReviewFormPopupStyles-cvaTerms', 'mb-4.8', 'text-cBlack64', '[&_a]:text-cMediumGreen']);

export const cvaButton = cva(['ReviewFormPopupStyles-cvaButton', 'w-full']);
